<section class="device-history" aria-labelledby="device-history-title">
  <details>
    <summary>
      <span class="history-title-group">
        <span id="device-history-title" class="history-title">
          {{ 'device_history.title' | translate }}
        </span>
        <span class="history-description">
          {{ 'device_history.description' | translate }}
        </span>
      </span>
      <span class="history-summary-status">
        {{ 'device_history.last_seen' | translate }}:
        <time
          *ngIf="history?.lastSeenAt; else neverSeenSummary"
          [attr.datetime]="history?.lastSeenAt"
          [title]="formatTime(history?.lastSeenAt)"
        >
          <span>{{ formatTime(history?.lastSeenAt) }}</span>
          <span class="relative-time">
            ({{ formatTimeAgo(history?.lastSeenAt) }})
          </span>
        </time>
        <ng-template #neverSeenSummary>
          {{ 'device_history.never' | translate }}
        </ng-template>
      </span>
      <span class="history-chevron" aria-hidden="true"></span>
    </summary>

    <div class="history-content">
      <div class="history-overview">
        <article class="history-stat">
          <span>{{ 'device_history.last_seen' | translate }}</span>
          <strong *ngIf="history?.lastSeenAt; else neverSeenOverview">
            <time
              [attr.datetime]="history?.lastSeenAt"
              [title]="formatTime(history?.lastSeenAt)"
            >
              <span>{{ formatTime(history?.lastSeenAt) }}</span>
              <span class="relative-time">
                ({{ formatTimeAgo(history?.lastSeenAt) }})
              </span>
            </time>
          </strong>
          <ng-template #neverSeenOverview>
            <strong>{{ 'device_history.never' | translate }}</strong>
          </ng-template>
        </article>

        <article *ngIf="hasCreationInfo" class="history-stat">
          <span>{{ 'device_history.created' | translate }}</span>
          <strong *ngIf="history?.createdAt; else creationTimeUnavailable">
            <time
              [attr.datetime]="history?.createdAt"
              [title]="formatTime(history?.createdAt)"
            >
              <span>{{ formatTime(history?.createdAt) }}</span>
              <span class="relative-time">
                ({{ formatTimeAgo(history?.createdAt) }})
              </span>
            </time>
          </strong>
          <ng-template #creationTimeUnavailable>
            <strong>{{ 'device_history.not_available' | translate }}</strong>
          </ng-template>
          <small *ngIf="creatorName">
            {{ 'device_history.created_by' | translate }} {{ creatorName }}
            <ng-container *ngIf="creatorImpersonatorName">
              {{ 'device_history.impersonated_by' | translate }}
              {{ creatorImpersonatorName }}
            </ng-container>
          </small>
        </article>
      </div>

      <section
        *ngIf="showLatestSoftwareSection"
        class="latest-software-section"
      >
        <div class="subsection-heading">
          <div>
            <h2>{{ 'device_history.latest_software.title' | translate }}</h2>
            <p>
              {{ 'device_history.latest_software.description' | translate }}
            </p>
          </div>
          <span
            *ngIf="latestSoftwareRequest"
            class="request-status"
            [class.request-error]="latestSoftwareRequestHasErrors"
          >
            {{
              latestSoftwareRequest.error ||
                (latestSoftwareRequestHasErrors
                  ? ('device_history.latest_software.error' | translate)
                  : ('device_history.latest_software.success' | translate))
            }}
          </span>
        </div>

        <ng-container *ngIf="latestSoftwareRequest; else noSoftwareRequest">
          <dl class="request-metadata">
            <div>
              <dt>{{ 'device_history.requested_at' | translate }}</dt>
              <dd>
                <time
                  [attr.datetime]="latestSoftwareRequest.time"
                  [title]="formatTime(latestSoftwareRequest.time)"
                >
                  <span>{{ formatTime(latestSoftwareRequest.time) }}</span>
                  <span class="relative-time">
                    ({{ formatTimeAgo(latestSoftwareRequest.time) }})
                  </span>
                </time>
              </dd>
            </div>
            <div *ngIf="latestSoftwareRequestType">
              <dt>{{ 'device_history.request_type' | translate }}</dt>
              <dd>{{ formatRequestType(latestSoftwareRequestType) }}</dd>
            </div>
          </dl>

          <app-effective-software-selection
            *ngIf="latestSoftwareComponents.length > 0"
            [resolutions]="latestSoftwareComponents"
            [showHeading]="false"
          ></app-effective-software-selection>

          <div
            *ngIf="latestSoftwareComponents.length === 0"
            class="empty-state"
          >
            {{ 'device_history.latest_software.no_components' | translate }}
          </div>
        </ng-container>

        <ng-template #noSoftwareRequest>
          <div class="empty-state">
            {{ 'device_history.latest_software.empty' | translate }}
          </div>
        </ng-template>
      </section>

      <section *ngIf="events.length > 0" class="events-section">
        <div class="subsection-heading">
          <div>
            <h2>{{ 'device_history.events.title' | translate }}</h2>
            <p>{{ 'device_history.events.description' | translate }}</p>
          </div>
          <span class="event-count">{{ events.length }}</span>
        </div>

        <div class="event-list">
          <article
            *ngFor="let event of events; let index = index; trackBy: trackEvent"
            class="event-row"
          >
            <div class="event-main">
              <strong>{{ formatEventType(event.eventType) }}</strong>
              <time
                [attr.datetime]="event.time"
                [title]="formatTime(event.time)"
              >
                <span>{{ formatTime(event.time) }}</span>
                <span class="relative-time">
                  ({{ formatTimeAgo(event.time) }})
                </span>
              </time>
            </div>

            <div class="event-details">
              <span *ngIf="getEventComponentCount(event) !== undefined">
                {{
                  'device_history.events.components'
                    | translate: { count: getEventComponentCount(event) }
                }}
              </span>
              <ng-container *ngIf="getEventDevicePayload(event) as payload">
                <span *ngIf="payload.certificateThumbprint">
                  {{ 'device_history.events.certificate' | translate }}:
                  <code>{{ payload.certificateThumbprint }}</code>
                </span>
              </ng-container>
              <span *ngIf="event.error" class="event-error">
                {{ event.error }}
              </span>
            </div>
          </article>
        </div>
      </section>
    </div>
  </details>
</section>
